module.exports = __webpack_public_path__ + "media/stylesheets/font/summernote-7c9436ed8d2deac04e375be2d373e647.woff2";